import { render } from "./client_add.vue?vue&type=template&id=c339586e"
import script from "./client_add.vue?vue&type=script&lang=js"
export * from "./client_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__